module.exports = __webpack_public_path__ + "img/CERTIFICATE_LANDING_PAGE_D969PU3DLF52.bc4ba3c5.jpeg";